import { render, staticRenderFns } from "./FilePreivew.htm?vue&type=template&id=0cd91c5a&scoped=true&"
import script from "./FilePreivew.ts?vue&type=script&lang=js&"
export * from "./FilePreivew.ts?vue&type=script&lang=js&"
import style0 from "./FilePreivew.scss?vue&type=style&index=0&id=0cd91c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd91c5a",
  null
  
)

export default component.exports